import { ConciliacionesProvider } from "@finanedi.es/front-ops"
import { FrontSharedProvider } from "@finanedi.es/front/common/providers"
import { NavBar } from "@finanedi.es/storybook"
import TokenSender from "@legacy/@gedesco/reactcomponentsgdc-v2.token-manager/TokenSender"
import { useArticulosInvalidation } from "api/Articulo.hook"
import { useAsesoriasInvitaciones } from "api/EmpresaGestionadaAsesoria.hook"
import { putEmpresaGestionadaAsesoriaEstadoInvitacion } from "api/EmpresaGestionadaAsesoria.service"
import { useImpuestoEmpresa } from "api/ImpuestoEmpresa.hook"
import { useUsuarioEmpresaActiva } from "api/Usuario.hook"
import NavBarChildren from "common/components/NavBar"
import WarningValidarCuenta from "common/components/WarningValidarCuenta"
import { GlobalTokenSenderContext } from "common/context/GlobalTokenSender"
import NotificationsProvider from "common/context/NotificationsProvider"
import useRealTime from "common/hooks/useRealTime"
import { useRealTimeAfterbanks } from "common/hooks/useRealTimeAfterbanks"
import notification from "common/utils/notification"
import ContactosProvider from "features/Contactos/context/ContactosProvider"
import ContactosModals from "features/Contactos/modals"
import {
  fetchAutorizacionesPendding,
  fetchCesionesAny,
  fetchCessionPendding,
  fetchMiUsuarioYEmpresas,
  userSelector,
} from "features/User/redux/slices/userSlice"
import { useAsociarDocumentosInvalidation } from "hooks/useAsociarDocumentos"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { useUsuarioByCurrent } from "hooks/useUsuarioByCurrent"
import { Message } from "primereact/message"
import { ProgressSpinner } from "primereact/progressspinner"
import { useContext, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import PrivateRouteList from "routes/PrivateRouteList"
import { ERP, FACTURAS, LOGIN } from "routes/RoutePaths"
import { fetchNeededData } from "routes/globalSlice"
import { ActiveCompanyChangedModal } from "./ActiveCompanyChangedModal"
import { asesoriasInvitacionesAdapter } from "./asesoriasInvitaciones.adapter"
import { ModalInvitacionesAsesorias } from "./components/ModalInvitacionesAsesorias/ModalInvitacionesAsesorias"
import "./dashboard.scss"

const DashboardContent = () => {
  const { t } = useTranslation()
  const { clearAccountsDomainStorage } = useContext(GlobalTokenSenderContext)
  const [collapsed, setCollapsed] = useState(false)
  const [openInvitation, setInvitation] = useState(false)
  const message = ""
  const history = useHistory()
  const {
    activeCompany: { verificada, razonSocial, asesoria },
    activeCompanyIsLoading,
    activeCompanyRefetch,
  } = useUsuarioEmpresaActiva()
  const { updateAllArticulosQueries } = useArticulosInvalidation()
  const { deleteInfiniteQueryAsociarDoc } = useAsociarDocumentosInvalidation()

  const { usuarioInternoInvalidation } = useUsuarioByCurrent()
  const { impuestoEmpresaInvalidation } = useImpuestoEmpresa()
  const { logged, loadingUserData } = useSelector(userSelector)
  const dispatch = useDispatch()
  const [showModalAsesoria, setShowModalAsesoria] = useState(false)

  const {
    asesoriasInvitaciones,
    asesoriasInvitacionesIsLoading,
    asesoriasInvitacionesRefetch,
    // @ts-expect-error TS(2345): Argument of type 'boolean | undefined' is not assi...
  } = useAsesoriasInvitaciones(!activeCompanyIsLoading && verificada)

  useEffect(() => {
    dispatch(fetchNeededData())
    impuestoEmpresaInvalidation()
    dispatch(fetchMiUsuarioYEmpresas())
    dispatch(fetchCessionPendding())
    dispatch(fetchCesionesAny())
    dispatch(fetchAutorizacionesPendding())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])

  useEffect(() => {
    dispatch(fetchCessionPendding())
    dispatch(fetchAutorizacionesPendding())
    dispatch(fetchCesionesAny())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useRealTime()
  useRealTimeAfterbanks()

  useEffect(() => {
    clearAccountsDomainStorage()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const routeRenderHandler = () => {
    window.location.replace(
      `${import.meta.env.REACT_APP_MY_ACCOUNT}${LOGIN}${ERP}`
    )
    return null
  }

  useEffect(() => {
    if (verificada) {
      asesoriasInvitacionesRefetch()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [razonSocial])

  const handleConfirmAsesoria = async (
    invitationsStatus: $TSMigrationFixMe
  ) => {
    try {
      await putEmpresaGestionadaAsesoriaEstadoInvitacion(
        invitationsStatus
      ).then(() => notification.success())
      activeCompanyRefetch()
      asesoriasInvitacionesRefetch()
      usuarioInternoInvalidation()
      deleteInfiniteQueryAsociarDoc()
      updateAllArticulosQueries()
      history.push(FACTURAS)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    }
  }

  if (loadingUserData) {
    return (
      <div
        id='principal-body'
        className='tw-relative tw-h-screen tw-w-full'
      >
        <ProgressSpinner
          style={{ position: "absolute", left: "50%", top: "50%" }}
        />
      </div>
    )
  }

  return (
    !activeCompanyIsLoading && (
      <>
        <div
          id='principal-body'
          className='tw-flex !tw-max-w-screen tw-items-stretch tw-relative'
        >
          {logged ? (
            <div className='tw-flex tw-flex-col lg:tw-flex-grow tw-h-screen !tw-w-full tw-relative tw-overflow-hidden'>
              <ConciliacionesProvider
                baseURL={`${import.meta.env.REACT_APP_GATEWAY}/`}
                accessToken={sessionStorage.getItem("access_token") || ""}
              >
                <FrontSharedProvider
                  baseURL={`${import.meta.env.REACT_APP_GATEWAY}/`}
                  accessToken={sessionStorage.getItem("access_token") || ""}
                >
                  <div className='tw-flex-grow tw-overflow-auto'>
                    <div className='order-1 tw-z-20 tw-absolute tw-bg-white tw-w-full'>
                      <NavBar classNameNavBar='tw-flex-grow tw-min-h-5 tw-z-0 tw-bg-primary lg:tw-bg-white tw-order-last tw-border-b tw-border-neutral-25'>
                        <NavBarChildren
                          // @ts-expect-error TS(2322): Type '{ showMdfIcon: true; secondary: false; openI...
                          showMdfIcon
                          secondary={false}
                          openInvitation={openInvitation}
                          setInvitation={setInvitation}
                          collapsed={collapsed}
                          setCollapsed={setCollapsed}
                        />
                      </NavBar>
                      <ActiveCompanyChangedModal
                        icon='exclamation-triangle'
                        confirmButtonLabel={t(
                          "activeCompanyChangedModal.confirmButtonLabel"
                        )}
                        onConfirm={() => {
                          window.location.reload()
                        }}
                        paragraph={t("activeCompanyChangedModal.paragraph")}
                      />
                      {verificada &&
                        !asesoria?.invitacionId &&
                        !asesoriasInvitacionesIsLoading &&
                        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
                        asesoriasInvitaciones?.totalCount > 0 && (
                          <Message
                            className='tw-w-full tw-pl-8 !tw-rounded-none !tw-border-t !tw-border-b !tw-border-info'
                            severity='info'
                            // @ts-expect-error TS(2769): No overload matches this call.
                            text={
                              <span>
                                {t("crear.asesoria.message")}
                                <span
                                  onClick={() => setShowModalAsesoria(true)}
                                  className='tw-cursor-pointer tw-underline tw-font-medium tw-ml-1'
                                >
                                  {t("crear.asesoria.openModalMessage")}
                                </span>
                              </span>
                            }
                          />
                        )}
                      {!verificada && (
                        <div className='warning__header'>
                          <WarningValidarCuenta />
                        </div>
                      )}
                    </div>
                    <div
                      className={`tw-z-10 order-2 tw-relative ${
                        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
                        asesoriasInvitaciones?.totalCount > 0 &&
                        !asesoria?.invitacionId
                          ? "tw-pt-27.5"
                          : "tw-pt-17.25"
                      } tw-w-full tw-h-screen tw-max-h-screen tw-bg-gray tw-overflow-y-scroll tw-overflow-x-hidden custom-scrollbar`}
                    >
                      <ContactosProvider>
                        <ContactosModals />
                        <PrivateRouteList />
                      </ContactosProvider>
                    </div>
                  </div>
                </FrontSharedProvider>
              </ConciliacionesProvider>
            </div>
          ) : (
            routeRenderHandler()
          )}
          <TokenSender
            message={message}
            targetUrl={import.meta.env.REACT_APP_ACCOUNTS}
          />
        </div>

        <ModalInvitacionesAsesorias
          isOpen={showModalAsesoria}
          onCloseModal={() => setShowModalAsesoria(false)}
          onConfirmAsesoria={handleConfirmAsesoria}
          // @ts-expect-error TS(2345): Argument of type 'GetInvitacionesAsesoriaDtoProps[...
          data={asesoriasInvitacionesAdapter(asesoriasInvitaciones?.items)}
        />
      </>
    )
  )
}

const Dashboard = () => {
  return (
    <NotificationsProvider>
      <DashboardContent />
    </NotificationsProvider>
  )
}

export default Dashboard
